<template>
    <div>
        <news-base-header-sec></news-base-header-sec>
        <div class="container-fluid base-container">
            <div class="base-box base-box__table-sec">
                <div class="card-body ac_card-body">

                    <ul class="ac_collapse__item-list">
                        <li class="ac_collapse__item" v-for="(item, index) in itemList" v-bind:key="index">
                            <div class="ac_collapse__item-header d-flex justify-content-between">
                                <h3 class="ac_collapse__item-title ">
                                    {{ item.title }}
                                </h3>
                                <span class="ac_collapse__item-title-date">{{
                                    moment(item.publishedDate).format('DD.MM.YYYY') }}</span>
                            </div>
                            <div class="ac_collapse__item-body">
                                <div v-if="item.description">
                                    {{ item.description }}
                                </div>
                                <div v-if="item.link">
                                    <div class="videoBox">
                                        <div class="videoWrapper">
                                            <iframe id="ytplayer" type="text/html" width="100%" height="360" frameborder="0"
                                                :src="item.link"></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="card-footer border-bottom">
                    <nav>
                        <ul class="pagination">
                            <li v-if="pageNum !== 0" class="page-item ">
                                <a class="page-link" @click.prevent='handleMultimediaPageDown' href="#">
                                    <span class="icon-chevrons-left mr-2"></span>
                                    Новије објаве
                                </a>
                            </li>
                            <li v-if="isMorePages" class="page-item ">
                                <a class="page-link" @click.prevent='handleMultimediaPageUp' href="#">
                                    Старије објаве
                                    <span class="icon-chevrons-right ml-2"></span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import NewsBaseHeaderSec from '@/components/NewsBaseHeaderSec.vue';
import axios from 'axios';


export default {
    name: "NewsMultimediaPage",
    data() {
        return {
            pageCounter: 0,
            itemList: null,
            baseApiUrl: window.env.VUE_APP_API_FP_DEV,
             
            isMorePages: true,
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },

        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    components: {

        NewsBaseHeaderSec
    },
    watch: {
        $route() {
            this.fetchMultimediaData();
        }
    },
    computed: {
        pageNum() {
            return this.$route.params.page
        }
    },
    methods: {
        handleMultimediaPageDown() {
            // this.router.push({ name: 'NewsCategoryPage', params: { userId: '123' } });
            let newPageNum;
            if (this.$route.params.page > 0) {
                newPageNum = Number(this.$route.params.page) - 1;
            } else {
                newPageNum = 0
            }

            this.$router.push({ name: 'NewsMultimediaPage', params: { page: newPageNum } });
            this.pageCounter++;
        },
        handleMultimediaPageUp() {
            let newPageNum;
            // this.router.push({ name: 'NewsCategoryPage', params: { userId: '123' } });
            newPageNum = Number(this.$route.params.page) + 1;
            this.$router.push({ name: 'NewsMultimediaPage', params: { page: newPageNum } });
            this.pageCounter++;
        },
        fetchMultimediaData() {
            axios
                .get(this.baseApiUrl + 'Prins/FilterMultimediaLinks?page=' + this.$route.params.page)
                .then(response => {

                    this.itemList = response.data.multimediaList;

                    if (this.itemList.length < 5) {
                        this.isMorePages = false
                    } else if (this.itemList.length === 5) {
                        this.isMorePages = true
                    }
                }).catch(function (error) {
                    console.log(error);
                });
        }
    },
    mounted() {
        this.fetchMultimediaData();
    },
    beforeCreate: function () {
        document.body.className = 'color_standard';
    }
}
</script>

<style>
.main {
    background-color: #ddd !important;
    padding-bottom: 360px !important;
}
</style>
